import axios from 'axios'
import qs from 'qs'
import md5 from 'js-md5';
import router from '../router'
import { Message } from 'iview'

export const baseURL = 'https://api.best-muster.com/Website' // 上传用这个
    // export const baseURL = 'https://api.paibaoex.com/Website'  //这是派宝的 
    // export const baseURL = 'http://39.99.246.93:8881/Website'
    // export const baseURL = 'http://192.168.0.77:801/'
    // const api = 'https://api.paibaoex.com'
const api = 'https://api.best-muster.com/'

localStorage.setItem('url', baseURL)
localStorage.setItem('api', api)

export const http = axios.create({
    baseURL: baseURL,
    headers: {
        "Content-Type": "application/x-www-form-urlencoded"
    },
    withCredentials: false,
    transformRequest: [function(data) {
        return qs.stringify(data);
    }]
});
export const post = async(url, data, contentType) => {

    const KeyText = localStorage.getItem("KeyText")
    const token = localStorage.getItem("token")
    const cusId = localStorage.getItem("CusID")
    const _md5 = md5(JSON.stringify(data) + KeyText)
    const para = {
        JsonData: JSON.stringify(data),
        CusID: cusId,
        KeyMd5: _md5,
        Token: token
    }
    return await http.post(url, contentType ? data : para)
}

http.interceptors.response.use(function(res) {
    if (res.data.Rem == 401) {
        Message.error(res.data.MsgText);

        router.push('./login')
    }
    handlerError(res.data)
    return res;
});

export const handlerError = ({
    code,
    msg
}) => {

};


// WEBPACK FOOTER //
// ./src/api/http.js